<div
  class="login-view"
  [style.background]="'url(/assets/images/' + background + ')'"
  [style.background-size]="'cover'"
>
  <div class="login-banner">
    <img src="/assets/images/apple-touch-icon-144x144-precomposed.png" height="64" style="display: inline-block; margin-top: -24px; margin-right: 24px; -webkit-filter: drop-shadow(1px 1px 0 grey) drop-shadow(-1px -1px 0 grey); filter: drop-shadow(1px 1px 0 grey) drop-shadow(-1px -1px 0 grey);"/>
    <h2 style="display: inline-block; margin-top: 12px;">Rail Viewer</h2>
  </div>
  <div
    class="login-form"
  >

    <h2>Login</h2>

    <div
      [style.margin-top.px]="10"
      [style.margin-bottom.px]="10"
      [style.color]="'white'"
      [style.background-color]="'red'"
    >
      Dear Railview users, this system has been deactivated.  Please contact your
      immediate supervisor or Metrolinx contact for more information and for alternative arrangements.
    </div>

    <!--
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="username">Username</label>
        <input
          type="text"
          formControlName="username"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
        />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
          <div *ngIf="f.username.errors.required">Username is required</div>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          formControlName="password"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
        />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required">Password is required</div>
        </div>
      </div>

      <div class="form-group">

        <button [disabled]="loading" class="btn btn-danger">Login</button>

        <div  *ngIf="loading" class="fa-lg" style="display: inline-block; margin-left: 8px;">
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>

      </div>

      <p>OR</p>

      <div class="form-group">
        <a href="{{google_sso}}"><img src="assets/images/google_signin_normal.png"></a>
      </div>

      <div class="form-group">
        <a style="color: black; text-decoration: none;" href="/privacy">Privacy</a>
      </div>

    </form>
    -->

  </div>

</div>
